module.exports = __webpack_public_path__ + "static/flags/AN-16f3dd910cc78a231f5563d40b645772.gif";